import { Component, ViewEncapsulation } from '@angular/core';
import { FiDocumentLayoutItem } from '../layout-item';
import { TemplateLayoutLanguageService } from '@fi-app/template/template-layout-language.service';

@Component({
    selector: 'fi-document-layout-item-site-map',
    templateUrl: './layout-item-site-map.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./layout-item-site-map.component.scss'],
    host: { class: 'fi-document-layout-item-site-map' },
    standalone: false,
})
export class FiDocumentLayoutItemSiteMapComponent extends FiDocumentLayoutItem {
    constructor(templateLayoutLanguageService: TemplateLayoutLanguageService) {
        super(templateLayoutLanguageService);
    }

    isEmpty(col) {
        return !(col && col.SiteMapId);
    }

    onAfterLoad(column: number) {
        setTimeout(() => this.onColumnAfterRender(column), 10);
    }
}
